export const MIGRATED_MODAL_ASSET = {
  local: {
    'pt-BR': 'https://junior-static.stg.openenglish.com/pt/JuniorBRTour.pdf',
    es: 'https://junior-static.stg.openenglish.com/es/Play2Learn.pdf',
    en: 'https://junior-static.stg.openenglish.com/es/Play2Learn.pdf',
  },
  stg: {
    'pt-BR': 'https://junior-static.stg.openenglish.com/pt/JuniorBRTour.pdf',
    es: 'https://junior-static.stg.openenglish.com/es/Play2Learn.pdf',
    en: 'https://junior-static.stg.openenglish.com/es/Play2Learn.pdf',
  },
  prod: {
    'pt-BR': 'https://junior-static.openenglish.com/pt/JuniorBRTour.pdf',
    es: 'https://junior-static.openenglish.com/es/Play2Learn.pdf',
    en: 'https://junior-static.openenglish.com/es/Play2Learn.pdf',
  },
};
